// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".GlossaryTermHighlight-term-2ppAO {\n  text-decoration: underline dashed;\n  text-underline-offset: 3px;\n  cursor: help;\n}\n", ""]);
// Exports
exports.locals = {
	"term": "GlossaryTermHighlight-term-2ppAO"
};
module.exports = exports;
